export default [{
	titulo: 'Vídeos',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/videos',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]